import type { FC } from "react";

interface SchemaInvalidBadgeProps {
  compact?: boolean;
}

/** Badge indicating a task failed with schema validation errors. */
export const SchemaInvalidBadge: FC<SchemaInvalidBadgeProps> = ({
  compact = false,
}) => (
  <span
    className={`inline-flex flex-shrink-0 items-center rounded-none font-mono text-[9px] font-bold uppercase tracking-[0.16em] text-rose-700 dark:text-rose-300 ${
      compact
        ? "gap-0.5 border border-rose-200 bg-rose-50 px-1 py-0.5 dark:border-rose-500/20 dark:bg-rose-500/10"
        : "gap-1 border border-rose-200 bg-rose-50 px-1.5 py-0.5 dark:border-rose-500/20 dark:bg-rose-500/10"
    }`}
  >
    <svg
      className={compact ? "h-2.5 w-2.5" : "h-3 w-3 flex-shrink-0"}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
        clipRule="evenodd"
      />
    </svg>
    {compact ? "Invalid" : <span>Schema Invalid</span>}
  </span>
);

interface CallbackStatusBadgeProps {
  status: { label: string; color: string };
  compact?: boolean;
}

/** Badge showing callback status (awaiting, received, error, etc.). */
export const CallbackStatusBadge: FC<CallbackStatusBadgeProps> = ({
  status,
  compact = false,
}) => (
  <span
    className={`inline-flex flex-shrink-0 items-center rounded-none border font-mono text-[9px] font-bold uppercase tracking-[0.16em] ${status.color} ${
      compact ? "px-1 py-0.5" : "gap-1 px-1.5 py-0.5"
    }`}
  >
    {!compact && (
      <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
          clipRule="evenodd"
        />
      </svg>
    )}
    {status.label}
  </span>
);
